import { useState } from 'react';

import { Box, Button, Grid, Stack, Typography } from '@mui/material';
import { Check, Save } from 'lucide-react';

import { Node } from '@modules/_shared/components/filters/advanced-filters/Node';
import { useFiltersSearchParams } from '@modules/_shared/components/filters/useFiltersSearchParams';
import { EditSmartListDialog } from '@modules/_shared/components/SmartListTitle';
import { useLocale } from '@shared/hooks/locale';

interface AdvancedFiltersProps {
  where: any;
  tableName: string;
  // `crm_entity` a saved view is filed under; the table name unless a view
  // keeps several lists apart on one table (Inbox / Sent).
  smartListEntity?: string;
  setWhere: (where: any) => void;
  queryParamsScope?: string;
}

export const AdvancedFilters = ({
  tableName,
  smartListEntity = tableName,
  where,
  setWhere,
  queryParamsScope,
}: AdvancedFiltersProps) => {
  const [showSaveDialog, setShowSaveDialog] = useState(false);
  const [, setFiltersSearch] = useFiltersSearchParams(queryParamsScope);
  const { t } = useLocale();

  return (
    <Grid container spacing={1.5} sx={{ p: 1.5 }}>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Node
          name="where"
          node={where}
          path={[`${tableName}_bool_exp`]}
          setWhere={setWhere}
          where={where}
        />
        <Stack direction="row" spacing={1} sx={{ mt: 1.5 }}>
          <Button
            variant="contained"
            disableElevation
            size="small"
            startIcon={<Check size={16} />}
            onClick={() => setFiltersSearch(where)}
            sx={{ fontSize: '0.8125rem' }}
          >
            {t('Apply filters')}
          </Button>
          <Button
            variant="action"
            size="small"
            startIcon={<Save size={16} />}
            onClick={() => setShowSaveDialog(true)}
            sx={{ fontSize: '0.8125rem' }}
          >
            {t('Save smart list')}
          </Button>
        </Stack>
      </Grid>
      <Grid
        size={{
          xs: 12,
          md: 6,
        }}
      >
        <Box
          sx={{
            bgcolor: 'grey.50',
            borderRadius: '8px',
            border: '1px solid',
            borderColor: 'grey.200',
            p: 1.5,
            overflow: 'auto',
            maxHeight: '40vh',
          }}
        >
          <Typography
            component="pre"
            sx={{
              m: 0,
              fontFamily: 'monospace',
              fontSize: '0.75rem',
              lineHeight: 1.6,
              color: 'text.secondary',
            }}
          >
            <code>{JSON.stringify(where, null, 2)}</code>
          </Typography>
        </Box>
      </Grid>
      <EditSmartListDialog
        open={showSaveDialog}
        smartList={{
          where,
          crm_entity: smartListEntity,
        }}
        onClose={() => setShowSaveDialog(false)}
        onUpdate={() => {}}
      />
    </Grid>
  );
};
